import DestinationController from './destination.controller.js';
import DestinationTypeSelectionController from './destination-type-selection.controller.js';
import DestinationAddController from './destination-add.controller.js';
import DestinationEditController from './destination-edit.controller.js';

// Import html templates
import './general-configuration/general-configuration.html';
import './children/children.html';
import destionationTpl from './destination.html';
import typeSelectionTpl from './destination.type_selection.html';
import destinationAddTpl from './destination.add.html';
import destinationEditTpl from './destination.edit.html';

export default function destinationsRouter($stateProvider) {
  $stateProvider
    .state('app.destination', {
      url: '/destination',
      templateUrl: destionationTpl,
      controller: DestinationController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['DESTINATION_READ'],
      },
    })
    .state('app.destination.type_selection', {
      url: '/type_selection',
      templateUrl: typeSelectionTpl,
      controller: DestinationTypeSelectionController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['DESTINATION_CREATE'],
      },
    })
    .state('app.destination.add', {
      url: '/:parentId/add',
      templateUrl: destinationAddTpl,
      controller: DestinationAddController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['DESTINATION_CREATE'],
      },
    })
    .state('app.destination.edit', {
      url: '/:destinationId',
      templateUrl: destinationEditTpl,
      params: {
        destinationId: null,
        retryOn404: null,
      },
      controller: DestinationEditController,
      controllerAs: 'vm',
      data: {
        authorizedPermissions: ['DESTINATION_READ'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/destinations/destinations.router.js